module.exports = __webpack_public_path__ + "static/media/search.530ce724.svg";